// 9fbef606107a605d69c0edbcd8029e5d
import logger from '@tcp/core/src/utils/loggerInstance';
import { getAPIConfig } from '@tcp/core/src/utils';
import handler from '../../../handler';

/**
 * Responsible for content fetching using content ID
 */
export const DataAbstractor = {
  getData: async (id) => {
    const { language } = getAPIConfig();
    return handler
      .fetchModuleDataFromGraphQL({
        name: 'moduleX',
        data: { cid: id, type: 'moduleX', lang: language !== 'en' ? language : '' },
      })
      .then((response) => (response ? response.data : {}));
  },
  processData: async (data) => {
    const result = {};
    const { name, composites: { richTextList } = {} } = data.moduleX || {};
    result.name = name;
    result.richText = richTextList && richTextList[0].text;
    return result;
  },
};

/**
 * Responsible for loading the rich text from CMS
 * @param {String} cid - Content ID
 */
export const getModuleX = async (cid) => {
  const { getData, processData } = DataAbstractor;
  let response = {};

  try {
    const data = await getData(cid);
    response = await processData(data);
  } catch (error) {
    logger.error(error);
  }
  return response;
};
